<template>
  <div v-if="tournaments && tournaments.length" class="upcoming-tournaments">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <TextLabel
        :text="
          $t('_web_newsfeed_upcoming-tournaments', `Tournaments`, {
            name: account._name,
          })
        "
      />
      <router-link
        :to="{
          name: 'competitions',
          params: {
            ...account.params,
            ...$route.params,
          },
        }"
        class="font-size-sm"
      >
        {{ $t('_web_newsfeed_upcoming-tournaments-see-all', 'See All') }}
      </router-link>
    </div>
    <Scroller :items="tournaments" show-arrows>
      <TournamentCard
        slot="item"
        slot-scope="{ item }"
        :tournament="item"
        class="upcoming-tournaments__tournament_card"
      />
    </Scroller>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import TextLabel from '@/components/atoms/TextLabel';
import Scroller from '@/components/posts/Scroller';
// import TournamentCard from '@/components/common/MyTournamentCard';
import TournamentCard from '@/components/common/TournamentCard';
import { translate } from '@/mixins/translate';
import { getNextPageData } from '@/mixins/lists';
export default {
  components: { TextLabel, TournamentCard, Scroller },
  mixins: [getNextPageData, translate('_web_account_competitions_list')],
  data() {
    return {
      tournaments: null,
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    competitionsQuery() {
      return {
        player: this.accountId,
        group: 'upcoming',
      };
    },
  },
  created() {
    this.fetchTournaments();
  },
  methods: {
    ...mapActions(['getCompetitionsAction']),
    fetchTournaments() {
      return this.getNextPageData(
        'tournaments',
        this.getCompetitionsAction({
          page: this.nextPageToken,
          ...this.competitionsQuery,
        }),
        {
          uniqBy: 'id',
        }
      );
    },
  },
};
</script>
<style lang="scss">
.upcoming-tournaments {
  .newsfeed-scroller_item {
    max-width: 300px;
  }
  &__tournament_card {
    width: 300px;
  }
}
</style>
